<template>
  <div :class="{ hideBeforeLoad: isNotLoaded, fadeAfterLoad: !isNotLoaded }">
    <main-header :template="template" role="banner" />
    <component :is="renderComponent" v-if="renderComponent" v-bind="data.bookingOptions" :title="data.title" />
    <ErrorModule v-else :message="notFoundError" :error="500" />
    <no-ssr>
      <Booking />
    </no-ssr>
  </div>
</template>

<script>
import MainHeader from '~/components/modules/MainHeader';
import BookingStay from '~/components/modules/BookingStay';
import ErrorModule from '~/components/modules/ErrorModule';
import Booking from '~/components/modules/Booking';
import asyncPageData from '~/utils/page';
import { createNamespacedHelpers } from 'vuex';
import { NAMESPACE } from '~/store/sitewide';

const { mapGetters } = createNamespacedHelpers(NAMESPACE);

export default {
  layout: 'book',
  transition: {
    name: 'fade',
    duration: { enter: 750, leave: 750 },
  },
  components: {
    BookingStay,
    ErrorModule,
    MainHeader,
    Booking,
  },
  data() {
    return {
      fromRoute: null,
      isNotLoaded: true,
    };
  },
  computed: {
    ...mapGetters(['metaDescription', 'companyName', 'cookieBannerAccepted']),
    renderComponent() {
      const componentType = this.$route.params.type;

      switch (componentType) {
        case 'stay': {
          return 'booking-stay';
        }
        default: {
          return false;
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
    });
  },
  async asyncData({ params, error, contentItem }) {
    return asyncPageData(params.location, error, contentItem);
  },
  mounted() {
    setTimeout(function() {
      this.isNotLoaded = false;
    }.bind(this),
    500);

    if (process.browser) {
      window.onNuxtReady(() => {
        // intercom script here
        window.intercomSettings = {
          app_id: 'kaotu1oq',
        };

        const w = window;
        const ic = w.Intercom;
        if (typeof ic === 'function') {
          ic('reattach_activator');
          ic('update', w.intercomSettings);
        } else {
          const d = document;
          const i = function() {
            // eslint-disable-next-line prefer-rest-params
            i.c(arguments);
          };
          i.q = [];
          i.c = function(args) {
            i.q.push(args);
          };
          w.Intercom = i;
          const l = function() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/kaotu1oq';
            s.defer = true;
            const x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      });
    }
  },
  methods: {
    cancel() {
      const prev = this.fromRoute ? this.fromRoute.fullPath : '/';
      this.$router.push({ path: prev });
    },
    getMetaTitle() {
      if (this.data && this.data.metaTitle) {
        return this.data.metaTitle;
      }

      if (this.title) {
        return this.getDefaultMetaTitle();
      }

      return `${this.companyName}`;
    },
    getDefaultMetaTitle() {
      return `${this.title} | ${this.companyName}`;
    },
    getMetaDescription() {
      if (this.data && this.data.metaDescription) {
        return this.data.metaDescription;
      }

      return this.metaDescription;
    },
  },
  head() {

    const metaTitle = this.getMetaTitle();
    const metaDescription = this.getMetaDescription();

    return {
      title: metaTitle,
      script: [
        {
          src: process.env.DEPLOY_STAGE.toLowerCase() === 'prod' ? process.env.MEWS_SCRIPT_SRC : process.env.MEWS_DEMO_SCRIPT_SRC,
          defer: true,
        },
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: metaDescription,
        },
      ],
    };
  },
};
</script>
